'use strict';

var viewportWidth;
var viewportHeight;
var viewportRatio;
var openCatTimeline;

var mainLanguage;

$(document).on('ready',function(){
    classMobile();
   
    mainLanguage = $('header').data('language');
   
    if (!$('body').hasClass('mobile')){
       $.html5Loader({
            filesToLoad:    
                    {
                    "files": [
                        /*{
                            "type": "VIDEO",
                            "sources": {
                                "h264": {
                                    "source": domain+"/chroma/themes/videos/about.mp4"
                                }
                            }
                        },*/
                        {
                            "type": "VIDEO",
                            "sources": {
                                "h264": {
                                    "source": domain+"/chroma/themes/videos/energie_v2.mp4"
                                }
                            }
                        },
                        {
                            "type": "VIDEO",
                            "sources": {
                                "h264": {
                                    "source": domain+"/chroma/themes/videos/greentech_v3.mp4"
                                }
                            }
                        },
                        {
                            "type": "VIDEO",
                            "sources": {
                                "h264": {
                                    "source": domain+"/chroma/themes/videos/impact.mp4"
                                }
                            }
                        }
                    ]
                },
            onBeforeLoad:       function () {},
            onComplete:         function () {
                // console.log('onComplete');
                loadWebsite();
            },
            onElementLoaded:    function ( obj, elm) { 
                // console.log(obj);
            },
            onUpdate:           function ( percentage ) {}
        });
    }
});

$(window).on('load',function(){
    if ($('body').hasClass('mobile')){
        loadWebsite();
    }
});

$(window).resize(function(){
	positionBgVideo();
});

function loadWebsite(){
    positionBgVideo();
    categoriesHoverVideo();
    navigation();
    checkRoute();

    if ($('#about_maps').length){
        google.maps.event.addDomListener(window, 'load', aboutGoogleMaps);
    }

    $('.overlayBegin').addClass('overlayHide');
    setTimeout(function(){
        $('.overlayBegin').removeClass('loading');
    },300);
}

function apparitionSplash(forceEnd=false){
	if (!$('body').hasClass('mobile')){
		var tl = new TimelineMax(); // { repeat:300, onUpdate:updateSlider, delay:1 }

		var splash = $('.splashScreenWrapper');
		var colLeft = splash.find('.col_left');
		var logo = colLeft.find('.logo');
		var h1 = colLeft.find('h1');
		var about = colLeft.find('.about');
		var colRight = splash.find('.col_right');
		var cats = colRight.find('.category');
		var catsBordersRight = cats.find('.borderRight');
		var catsInfos = cats.find('.infos');

		/*** ANIMATION COLONNE DE GAUCHE - TEXT ***/

		tl.set(colLeft, { width: '100%' });
		tl.set(colRight, { width: '0%' });
		tl.set(logo, { opacity: 0 });
		tl.set(h1, { opacity: 0, y: '-10' });
		tl.set(about, { opacity: 0 });
		tl.set(catsBordersRight, { opacity: 0, height: 0 });
		tl.set(catsInfos, { opacity: 0, y: '-10' });

		tl.addLabel("Phase1");

		tl.to(logo, 1, { opacity: 1, ease: Back.easeIn.config(1) },"Phase1");
		tl.to(h1, 1, { opacity: 1, y: '0', delay: 0.25, ease: Back.easeOut.config(1) },"Phase1");

		tl.addLabel("Phase2");

		tl.to(colLeft, 0.8, { 'width': '50%', delay: 0, ease: Back.easeOut.config(1.7) },"Phase2");
		tl.to(colRight, 0.8, { 'width': '50%', delay: 0, ease: Back.easeOut.config(1.7) },"Phase2");

		tl.addLabel("Phase3");

		tl.staggerTo(catsBordersRight, 0.5, { opacity: 1, height: '100%', delay:'-0.5' }, 0.3,"Phase3-=0.5");
        tl.to(about, 1, { opacity: 1, ease: Back.easeOut.config(1.7) });
		tl.staggerTo(catsInfos, 0.5, { opacity: 1, y: 0, delay:'0.5' }, 0.3,"Phase3");

		if (forceEnd) tl.progress(1, false);
	}
}

function goToCategory($this,forceEnd=false){
    var href = $this.data('href');
    var alias = $this.data('alias');
    console.log('goToCategory '+href);
    
    clearTimeout(scrollDownTimeout);
    
    var infos = $this.find('.infos');
    var h2 = $this.find('h2');
    var h3 = $this.find('h3');
	var desc = $this.find('p.desc');
    var otherCategories = $('.col_right .category').not($this);

    var easingOpa = Power1.easeOut;
    var easingMove = Power3.easeOut;

	if ($('body').hasClass('mobile')){
		$('.splashScreenWrapper').hide();
	}
	else{
        // On change la vidéo d'intro
        playVideoBackground($this);
        
		// Init Timeline
		openCatTimeline = new TimelineMax();

		openCatTimeline.addCallback(function(){
			$this.toggleClass('clicked');
		});
		// On ouvre l'élement, On cache les contenus
		openCatTimeline.addLabel("Phase1");
		console.log('viewportWidth '+viewportWidth);
		openCatTimeline.set($this, { clearProps:"all" },"Phase1");
		openCatTimeline.set(desc, { clearProps:"all" },"Phase1");
		openCatTimeline.set(otherCategories, { clearProps:"all" },"Phase1");
		openCatTimeline.to($('.col_left .col_inner'), 0.2, { opacity: 0, ease: easingOpa },"Phase1");
		openCatTimeline.to($('.col_left .about'), 0.2, { opacity: 0, ease: easingOpa },"Phase1");
		openCatTimeline.to($('.col_left'), 0.5, { width: '0%', ease: easingMove },"Phase1");
		openCatTimeline.to($('.col_right'), 0.5, { width: '100%', ease: easingMove },"Phase1");
		openCatTimeline.to($this, 0.2, { 'flex-basis': '100%',  ease: easingMove },"Phase1");
		openCatTimeline.set($this, { cursor: 'default' },"Phase1");
		openCatTimeline.set(infos, { width: '100%', opacity: 1 },"Phase1");
		openCatTimeline.to(desc, 0.25, { opacity: 0, ease: easingOpa },"Phase1");
		openCatTimeline.to($this.find('.readmore'), 0.25, { opacity: 0, ease: easingOpa },"Phase1");
		openCatTimeline.to(otherCategories, 0.2, { 'flex-basis': '0%', ease: easingMove },"Phase1");
		openCatTimeline.to(infos, 0.25, { left: 0, ease: easingMove },"Phase1");
		openCatTimeline.to(otherCategories.find('.infos'), 0.25, { opacity: 0, ease: easingMove },"Phase1");
		openCatTimeline.to($('.col_right .borderRight'), 0.2, { opacity: 0, delay: 1, ease: easingOpa },"Phase1");
		openCatTimeline.to($('.col_right .category').not, 0.2, { opacity: 0, ease: easingOpa },"Phase1");

		// On affiche juste le titre de la page
		openCatTimeline.set(h2, { opacity: 0, y: '-30', 'font-size': '120px', 'font-weight': 'bold', 'text-align': 'center' },"Phase1");
		openCatTimeline.set(h3, { y: '-30', display: 'block' },"Phase1");
		openCatTimeline.addLabel("Phase2","=-0.8");
		openCatTimeline.to(h2, 0.2, { opacity: 1, y: 0, ease: Back.easeOut.config(1.7) },"Phase2");
		openCatTimeline.to(h3, 0.2, { opacity: 1, y: 0, ease: Back.easeOut.config(1.7) },"Phase2+=0.1");
        
		openCatTimeline.to($('.videos .video.active'), 0.5, { opacity: 0.5, ease: easingOpa },"Phase2+=0.1");

		if (forceEnd) openCatTimeline.progress(1, false);
	}

    // On charge en ajax le contenu en dessous
    // $.get(href+"?ajax=1", function(main){
    $.get(domain+"/chroma/controllers/AjaxController.php?route="+alias+"&language="+mainLanguage, function(main){
        $('main').empty().append(main).addClass('active');

        var title = $this.find('h2').text();
        
        changeHistory(title,href);

        animationsCategoryPage();
            
        scrollDownTitle(forceEnd);

        openHeader();
        
        $('.overlayBegin').addClass('overlayHide');
    });
}
    
function goToAbout($this,forceEnd=false){
    console.log('goToAbout');
    var href = $this.data('href');
    var alias = $this.data('alias');
    var title = $this.find('h2').text();
    
    var easingOpa = Power1.easeOut;
    var easingMove = Power3.easeOut;

	if ($('body').hasClass('mobile')){
		$('.splashScreenWrapper').hide();
	}
	else{
		// Init Timeline
		openCatTimeline = new TimelineMax();

		openCatTimeline.addCallback(function(){
			$this.toggleClass('clicked');
		});
        
        var colLeft = $('.col_left');
        var col_inner = colLeft.find('.col_inner');
        var col_about = colLeft.find('.about');
        var h1 = colLeft.find('h1');
        var h2_home = col_about.find('h2.about_home');
        var h2_title = col_about.find('h2.about_title');
        var h3 = col_about.find('h3');
        var readmore = col_about.find('readmore');
        
        var transitionVolets = 1; // 1s
        
		// On ouvre l'élement, On cache les contenus
		openCatTimeline.addLabel("Phase0");
        openCatTimeline.to(col_inner, 0.2, { opacity: 0, ease: easingOpa },"Phase0");
        openCatTimeline.to(readmore, 0.2, { opacity: 0, ease: easingOpa },"Phase0");
        
		openCatTimeline.addLabel("Phase1");
        openCatTimeline.set(col_inner, { height: 0 },"Phase1");
        openCatTimeline.set(h2_home, { opacity: 0 },"Phase1");
        openCatTimeline.set(h2_title, { opacity: 0, y: '-30', 'font-size': '90px', 'font-weight': 'bold', 'text-align': 'center' },"Phase1");
		openCatTimeline.set(h3, { opacity: 0, y: '-30', display: 'block' },"Phase1");
		openCatTimeline.set(col_about, { opacity: 1 },"Phase1");
		openCatTimeline.to(colLeft, transitionVolets, { width: '100%', ease: easingMove },"Phase1");
		openCatTimeline.to(colLeft.find('.aboutBg'), transitionVolets, { opacity: 1, ease: easingOpa },"Phase1");
		openCatTimeline.to($('.col_right'), transitionVolets, { width: '0%', ease: easingMove },"Phase1");
        
        openCatTimeline.addLabel("Phase2");
        openCatTimeline.to(h1, 0.5, { color: 'white', ease: easingOpa },"Phase2-=0.5");
        openCatTimeline.to(col_about, 0.5, { height: '100%', ease: easingOpa },"Phase2-=0.5");
        
		openCatTimeline.addLabel("Phase2","=-0.8");
		openCatTimeline.to(h2_title, 0.2, { opacity: 1, y: 0, ease: Back.easeOut.config(1.7) },"Phase2");
		openCatTimeline.to(h3, 0.2, { opacity: 1, y: 0, ease: Back.easeOut.config(1.7) },"Phase2+=0.1");
        
		if (forceEnd) openCatTimeline.progress(1, false);
	}
	
	// On charge en ajax le contenu en dessous
    //$.get(href+"?ajax=1", function(main){
    $.get(domain+"/chroma/controllers/AjaxController.php?route="+alias+"&language="+mainLanguage, function(main){
        $('main').empty().append(main).addClass('active');

        changeHistory(title,href); // On change l'url de la page

        onLoadAbout(forceEnd);

        $('.overlayBegin').addClass('overlayHide');
    });
}

function onLoadAbout(forceEnd=false){
    if ($('#about_maps').length){
        aboutGoogleMaps(); // Chargement carte
    }
        
    if ($('.slice_about_numbers').length){
        var inview = new Waypoint.Inview({
            element: $('.slice_about_numbers .numbers')[0],
            enter: function(direction) {
                var delay = 0;
				inview.destroy();
                $('.numbers .number').each(function(){
                    var $this = $(this);

                    var number = $this.text();
                    $this.data('number-initial',number);
                    $this.empty().append(0);

                    var durationApparition = 3; // 5s
                    var intervalSpeed = (durationApparition / number) * 1000;

                    var n = 0;
                    setTimeout(function(){
                        var intervalNumber = setInterval(function(){
                            // console.log('intervalNumber '+number);
                            if (n <= number){
                                $this.empty().append(n);
                                n++;
                            }
                            else{
                                clearInterval(intervalNumber);
                            }
                        },intervalSpeed);
                    },delay);
                    delay += 500;
                });
            }
        });
    }

    scrollDownTitle(forceEnd);

    if (forceEnd) openHeader();
}

var scrollDownTimeout;
function scrollDownTitle(forceEnd=false){
    if (!$('body').hasClass('mobile')){
        scrollDownTimeout = setTimeout(function(){
            if (window.pageYOffset == 0){
                var splashHeight = $('.splashScreenWrapper').height();
                var offsetH2Top = $('.clicked h2').offset().top;
                var offsetH3Top = $('.clicked h3').offset().top;
                var h3Height = $('.clicked h3').height();
                var headerHeight = $('header').height();
                
                var distanceBottom = splashHeight - offsetH3Top - h3Height;
                
                /*console.log('splashHeight '+splashHeight);
                console.log('offsetH2Top '+offsetH2Top);
                console.log('h3 '+h3Height);
                console.log('headerHeight '+headerHeight);
                console.log('distanceBottom '+distanceBottom);*/
                
                offsetH2Top = offsetH2Top - distanceBottom - headerHeight;
                TweenMax.to(window, 1, { scrollTo: offsetH2Top, ease: Back.easeOut.config(1.4) });
            }
            if (!forceEnd) openHeader();
        },2000);
    }

	var mainScrollTop = $('.splashScreenWrapper').height();
	var copyright = $('.copyright');
	var offsetMain = mainScrollTop*0.5;
	
	$(window).scroll(function() {
		var scroll = $(window).scrollTop();
		if (scroll > offsetMain){
			if (!copyright.hasClass('showed')){
				copyright.addClass('showed');
			}
		}
		else{
			if (copyright.hasClass('showed')){
				copyright.removeClass('showed');
			}
		}
	});
	
	/*var inviewCopyright = new Waypoint.Inview({
		element: $('main')[0],
		offset: '500px',
		entered: function(direction) {
			console.log('entered');
			$('.copyright').addClass('showed');
		},
		exit : function(direction) {
			console.log('exited');
			$('.copyright').removeClass('showed');
		},
	})*/
}

function goToHome(){
    if ($('body').hasClass('mobile')){
		$('.splashScreenWrapper').show();
	}
	else{
		apparitionSplash();
	}
}
    
var timelineHeader = new TimelineMax();
    
function goBackHome(){
	if ($('body').hasClass('mobile')){
		$('.splashScreenWrapper').show();
	}
	else{
		openCatTimeline.reverse();
	}
    
    timelineHeader.reverse();
    $('main').empty().removeClass('active');
}

function openHeader(){
    var header = $('header');
    
    if (!header.hasClass('open')){
        timelineHeader.addCallback(function(){
            header.toggleClass('open');
        });
        var headerHeight = header.height();
        
        if ($('body').hasClass('mobile')){
            timelineHeader.set(header,{ y: 0 });
        }
        else{
            timelineHeader.set(header,{ y: -headerHeight+'px' });
            timelineHeader.to(header, 1, { y: 0, clearProps: 'all', ease: Power2.easeOut });
        }
    }
    
    /*var waypoint = new Waypoint({
        element: $('.slice_intro')[0],
        handler: function() {
            
            
            this.destroy();
        }
    });*/
}

function playVideoBackground($this){
    var num = $('.col_right .category').index($this);
    var video = $('.splashScreenWrapper .videos .video').eq(num);
    
    $('.splashScreenWrapper .videos .video').each(function(){
		var $vid = $(this);
        $vid[0].pause();
		$vid.removeClass('active').stop().animate({ 'opacity': 0 },500);
    });
	
	if (video.length){
        console.log('playVideoBackground');
		video[0].play();
		video.addClass('active').stop().animate({ 'opacity': 0.5 },500);
	}
}
  
var intervalSolutionEnergieVerte;
function animationsCategoryPage(){
    // Rotation du filigrane
    // if ($('.filigrane').length){
    //     TweenMax.to($('.filigrane'), 180, {rotation:"360", ease:Linear.easeNone, repeat:-1});
    // }

    // Energie Verte
    /**********************************************************/
    if ($('.slice_energieverte_intro .solutions').length > 0){
        
        var video = $('.slider_pictos').find('video').eq(0);
        video[0].play();
    }
    
    if ($('.quote_slider').length){
        $('.quote_slider').slick({
            autoplay: true,
            autoplaySpeed: 4000,
            fade: true,
            pauseOnHover: false,
        });
    }
	
	if ($('.slider_photos').length){
		$('.slider_photos').slick({
            autoplay: true,
            autoplaySpeed: 4000,
            fade: true,
            pauseOnHover: false,
        });
	}
	
	if ($('.services_wrapper').length){
		$('.service').css({ 'opacity': 0 });
		
		var inview = new Waypoint.Inview({
			element: $('.services_wrapper')[0],
			enter: function(direction) {
			  TweenMax.staggerTo($('.service'), 0.5, { opacity: 1 }, 0.3);
			}
		})
		
		$('.service').hover(function(){
			var $this = $(this);
			var front = $this.find('.front');
			var back = $this.find('.back');
			var backHeight = back.height();
			
			var timelineService = new TimelineMax();
			timelineService.set(back, { y: backHeight+'px', z:0 });
			timelineService.to(front, 0.3, { y: -backHeight+'px', z:0, ease: Power3.easeInOut },'Phase1');
			timelineService.to(back, 0.3, { opacity: 1, y: '0px', ease: Power3.easeInOut },'Phase1');
		},function(){
			var $this = $(this);
			var front = $this.find('.front');
			var back = $this.find('.back');
			var backHeight = back.height();
			
			var timelineService = new TimelineMax();
			timelineService.to(front, 0.2, { y: '0px', z:0, ease: Power3.easeInOut },'Phase1');
			timelineService.to(back, 0.2, { opacity: 0, y: backHeight+'px', z:0, ease: Power3.easeInOut },'Phase1');
		});
	}
}
         
function classMobile(){
    viewportWidth = $( window ).width();
    viewportHeight = $( window ).height();
    viewportRatio = viewportWidth / viewportHeight;
    
    if (viewportWidth < 991){
        $('body').addClass('mobile');
    }
    else{
        $('body').removeClass('mobile');
    }
}

function positionBgVideo(){
    classMobile();
    
    function checkVideoSize(vid){
        var video = $(vid);
        video.addClass('loaded');
        // var videoWidth = vid.videoWidth;
        var videoWidth = 1280;
        //var videoHeight = vid.videoHeight;
        var videoHeight = 720;
        var videoRatio = videoWidth / videoHeight;
        // console.log('videoWidth '+videoWidth+' / videoHeight '+videoHeight);
        // console.log('videoRatio '+videoRatio);
        var ratioW = (viewportWidth/videoWidth);
        var ratioH = (viewportHeight/videoHeight);
        // console.log('ratio width '+ratioW+' ratio height '+(viewportHeight/videoHeight));

        if (videoRatio < viewportRatio){
            if (ratioW > ratioH){
                video.width(viewportWidth);
                var newHeight = (videoHeight*viewportWidth)/videoWidth;
                video.height(newHeight);
                var diffHeight = (newHeight - viewportHeight);
                video.css({ top : -(diffHeight / 2)+'px', left: 0 });
            }
        }
        else{
            if (ratioW < ratioH){
                video.height(viewportHeight);
                var newWidth = (videoWidth*viewportHeight)/videoHeight;
                video.width(newWidth);
                var diffWidth = (newWidth - viewportWidth);
                video.css({ top: 0, left : -(diffWidth / 2)+'px' });
            }
        }
    }

    $('.videos video').each(function(){
        var vid = $(this);
        
        checkVideoSize(this);
    });
}
    
function categoriesHoverVideo(){
	$(document).on({
        mouseenter: function(){
            var $this = $(this);
        
			if (!$('main').hasClass('active')){
				// TweenMax.to($this, 0.3, { 'flex-basis': '40%', ease: Power3.easeOut });
				playVideoBackground($this);
			}
        },
        mouseleave: function(){
            // On laisse la vidéo allumée si on est dans une page interne
			if (!$('main').hasClass('active')){
				var $this = $(this);
				
				// TweenMax.to($this, 0.1, { 'flex-basis': '33.33%', ease: Power3.easeOut });
				var num = $('.col_right .category').index($this);
				var video = $('.splashScreenWrapper .videos .video').eq(num);
				video[0].pause();
				video.removeClass('active');
				video.animate({ 'opacity': 0 },500);
			}
        }
    }, '.splashScreenWrapper .category');
    
    $(document).on({
        mouseenter: function(){
            var $this = $(this);
            var num = $('.slice_footer_nav .category').index($this);
            var video = $('.slice_footer_nav .videos .video').eq(num);

            $('.slice_footer_nav .videos .video').each(function(){
                var $vid = $(this);
                $vid[0].pause();
                $vid.removeClass('active');
            });
            console.log('categoriesHoverVideo slice_footer_nav mouseenter');
            video[0].play();
            video.addClass('active').stop().animate({ 'opacity': 0.1 },500);
        },
        mouseleave: function(){
            var $this = $(this);
            var num = $('.slice_footer_nav .category').index($this);
            var video = $('.slice_footer_nav .videos .video').eq(num);
            video[0].pause();
            video.removeClass('active');
            video.animate({ 'opacity': 0 },500);
        }
    }, '.slice_footer_nav .category');
    
    $(document).on({
        mouseenter: function(){
            var $this = $(this);
            var video = $this.find('video');
            console.log('categoriesHoverVideo slice_about_activities activity mouseenter');
            video[0].play();
        },
        mouseleave: function(){
            var $this = $(this);
            var video = $this.find('video');
            video[0].pause();
        }
    }, '.slice_about_activities .activity');
}

function navigation(){
    $(document).on('click', '.splashScreenWrapper .col_right .category', function(){
        var $this = $(this);
        
        if (!$this.hasClass('clicked')){
            goToCategory($this);
        }
    });
    
    $(document).on('click', '.about', function(){
        var $this = $(this);
        
        if (!$this.hasClass('clicked')){
            goToAbout($this);
        }
    });
    
    $(document).on('click', '.navbar-nav a, .footer_nav a, .row_activities a.activity', function() {
        $('.overlayBegin').removeClass('overlayHide');
        
        var href = $(this).attr('href');
        
        // On ferme le menu mobile s'il est ouvert
        if ($('.navbar-collapse').hasClass('in')){
            $('.navbar-toggle').trigger('click');
        }
		
		// Classes du menu
		$('.col_left .about, .col_right .category').removeClass('clicked');
        
        setTimeout(function(){
            // window.location.href = hrefPage;
            // On remonte en haut de la page
            window.scrollTo(0,0);
			
            // On va à la bonne page
            var linkCategory = $('.col_right .category[href="'+href+'"]');
            if (linkCategory.length){
                goToCategory(linkCategory,true);
            }
            else{
                goToAbout($('.col_left .about'),true);
            }
        },300);
    });
}

function checkRoute(){
    /*var pathExp = window.location.pathname.split('/');
    var path = pathExp[1];*/
    var hash = window.location.hash;
    var hashRoute = hash.substr(2);
    var hashExp = hashRoute.split('/');
    var hashAlias = hashExp[0];
    
    if (hashAlias != ''){
        var linkCategory = $('.col_right .category[data-alias="'+hashAlias+'"]');
        
        if (linkCategory.length > 0){
            console.log('plop');
            apparitionSplash(true);
            goToCategory(linkCategory,true);
        }
        else if ($('.col_left .about').data('alias') == hashAlias){
            apparitionSplash(true);
            goToAbout($('.col_left .about'),true);
        }
        else{
            goToHome();
        }
    }
    else{
        goToHome();
    }
}

function changeHistory(title,url){
    /*var myNewState = {
        title: title,
        url: url
    };
    history.pushState(myNewState.data, myNewState.title, myNewState.url);*/
}

/*window.onpopstate = function(event) {
    if (event.state == null){
        var myNewState = {
            title: "Chroma",
            url: "/"
        };
        history.pushState(myNewState.data, myNewState.title, myNewState.url);
        
        goBackHome();
    }
};*/

/*
history.pushState({page: 1}, "title 1", "?page=1");
history.pushState({page: 2}, "title 2", "?page=2");
history.replaceState({page: 3}, "title 3", "?page=3");
history.back(); // alerts "location: http://example.com/example.html?page=1, state: {"page":1}"
history.back(); // alerts "location: http://example.com/example.html, state: null
history.go(2);  // alerts "location: http://example.com/example.html?page=3, state: {"page":3}
*/

function aboutGoogleMaps() 
{
    // Basic options for a simple Google Map
    // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions

    var poslat = 50.656923;
    var poslng = 4.623960;
    // var centerlat = 50.753090767928676;
    var centerlat = poslat;
    // var centerlng = 4.3727165449219;
    var centerlng = poslng;
    var zoom = 10;
    
    var positionPin = new google.maps.LatLng(poslat,poslng);
    var centerMap = new google.maps.LatLng(centerlat,centerlng);

    var myOptions = {
        zoom: zoom,
        center: centerMap,
        scrollwheel: false,
        scaleControl: false,
        draggable: true,
        zoomControl: true,
        disableDoubleClickZoom: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: greyChroma
    };

    var mymap = new google.maps.Map(document.getElementById('about_maps'), myOptions);

    var customIcon = {
          url: domain+'/chroma/themes/img/pin.png',
          size: new google.maps.Size(34, 42),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 42)
    };
        
    var myMarker = new google.maps.Marker(
    {
        position: positionPin,
        map: mymap,
        animation: google.maps.Animation.DROP,
        // icon: '/files/design/gmaps_pin.png'
        icon: customIcon
    });

    var myInfoWindows = new google.maps.InfoWindow({ 
        content: $('.slice_about_map .infos').html() 
    });
    myInfoWindows.open(mymap,myMarker); 
    google.maps.event.addListener(myMarker, 'click', function(){ 
        myInfoWindows.open(mymap,myMarker); 
    });
    
    google.maps.event.addDomListener(window, 'resize', function(){
        mymap.setCenter(centerMap);
    });
	
	google.maps.event.addListener(mymap, 'dragend', function() { 
		console.log('lat '+mymap.getCenter().lat() );
		console.log('lng '+mymap.getCenter().lng() );
	});
}

var greyMap = [{"featureType":"landscape","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"stylers":[{"hue":"#00aaff"},{"saturation":-100},{"gamma":2.15},{"lightness":12}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"lightness":24}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":57}]}];


var greyChroma = [
    {
        "featureType": "administrative",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.province",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "color": "#008da4"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.attraction",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            },
            {
                "visibility": "simplified"
                // "visibility": "on"
            },
            {
                "weight": "3.00"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text",
        "stylers": [
            {
                "weight": "7.44"
            },
            {
                "gamma": "0.28"
            },
            {
                "lightness": "37"
            },
            {
                "saturation": "37"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "weight": "2.78"
            },
            {
                "gamma": "1.02"
            },
            {
                "lightness": "-2"
            }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "weight": "2.99"
            }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "labels.text",
        "stylers": [
            {
                "weight": "6.78"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text",
        "stylers": [
            {
                "weight": "5.79"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#7fd2f4"
            },
            {
                "visibility": "on"
            }
        ]
    }
];
